





































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import ItemCycler from '@/components/Cycler/ItemCycler.vue';
import { ItemCyclerSlide, ItemCyclerImageSlide } from '@/app_code/ItemCycler';
import NavigationLink from './NavigationLink.vue';

@Component({
  components: {
    NavigationLink,
    ItemCycler,
  },
})
export default class Header extends Vue {
  public mobileNavActive = false;

  public cyclerImages: ItemCyclerSlide[] = [
    new ItemCyclerImageSlide({
      source: '/assets/images/land/slider/1',
      formats: ['jpg'],
      fallback: 'jpg',
    }),
    new ItemCyclerImageSlide({
      source: '/assets/images/land/slider/2',
      formats: ['jpg'],
      fallback: 'jpg',
    }),
    new ItemCyclerImageSlide({
      source: '/assets/images/land/slider/3',
      formats: ['jpg'],
      fallback: 'jpg',
    }),
    new ItemCyclerImageSlide({
      source: '/assets/images/land/slider/4',
      formats: ['jpg'],
      fallback: 'jpg',
    }),
    new ItemCyclerImageSlide({
      source: '/assets/images/land/slider/5',
      formats: ['jpg'],
      fallback: 'jpg',
    }),
    new ItemCyclerImageSlide({
      source: '/assets/images/land/slider/6',
      formats: ['jpg'],
      fallback: 'jpg',
    }),
    new ItemCyclerImageSlide({
      source: '/assets/images/land/slider/7',
      formats: ['jpg'],
      fallback: 'jpg',
    }),
  ];

  toggleMenu(event: Event) {
    const btn = event.currentTarget as HTMLElement;
    const closeBtn = this.$refs.closeMenuBtn as HTMLElement;
    const openBtn = this.$refs.openMenuBtn as HTMLElement;
    let toggleState;

    const nav = this.$refs.primaryNavigation as HTMLElement;
    nav.classList.add('header__nav--activated');
    nav.addEventListener(
      'transitionend',
      () => {
        nav.classList.remove('header__nav--activated');
      },
      { once: true },
    );

    if (btn.getAttribute('aria-expanded') === 'true') {
      document.body.classList.remove('no-scroll');
      toggleState = 'false';
    } else {
      document.body.classList.add('no-scroll');
      toggleState = 'true';
    }

    closeBtn.setAttribute('aria-expanded', toggleState);
    openBtn.setAttribute('aria-expanded', toggleState);
    nav.setAttribute('data-visible', toggleState);
  }

  mounted() {
    this.$router.afterEach(() => {
      this.mobileNavActive = false;
    });
  }

  @Watch('$route')
  closeMenu() {
    const closeBtn = this.$refs.closeMenuBtn as HTMLElement;
    const openBtn = this.$refs.openMenuBtn as HTMLElement;
    const nav = this.$refs.primaryNavigation as HTMLElement;

    document.body.classList.remove('no-scroll');
    closeBtn.setAttribute('aria-expanded', 'false');
    openBtn.setAttribute('aria-expanded', 'false');

    nav.setAttribute('data-visible', 'false');
    nav.classList.add('header__nav--activated');
    nav.addEventListener(
      'transitionend',
      () => {
        nav.classList.remove('header__nav--activated');
      },
      { once: true },
    );
  }
}
